module.exports = __webpack_public_path__ + "media/images/riders/MAXIME_MAROTTE-81c88088cdd56ce491755813ba539e45.png";